// extracted by mini-css-extract-plugin
module.exports = {"label":"_02712f2b3b--label--lCSWa","icon":"_02712f2b3b--icon--Yd5h9"};